import { inject, TemplateRef } from "@angular/core";

import { EmptyObject } from "types/empty-object";

/** Apply @Directive decorator in subclasses */
export abstract class TemplateMarkerDirective<T = EmptyObject> {
  public readonly templateRef = inject<TemplateRef<T>>(TemplateRef);
}
